export default __webpack_public_path__ + "img/treatment-chart.4fb6cba2.png";